export const DefaultColorScheme = {
    "palettes": [
        {
            "id": "palette1",
            "ranges": ["#1D5D9B", "#009C36", "#00909E", "#FFBD59", "#B32D46"]
        },
        {
            "id": "palette2",
            "ranges": ["#00909E", "#9E1857", "#00909E", "#F6645D", "#009C36"]
        },
        {
            "id": "palette3",
            "ranges": ["#00909E", "#FFBD59", "#F6645D", "#FFBD59", "#009C36"]
        },
        {
            "id": "palette4",
            "ranges": ["#FFBD59", "#00909E", "#F6645D", "#FFBD59", "#009C36"]
        },
        {
            "id": "palette5",
            "ranges": ["#F6645D", "#FFBD59", "#F6645D", "#FFBD59", "#009C36"]
        },
        {
            "id": "palette6",
            "ranges": ["#00909E", "#FFFFFF", "#F6645D", "#FFBD59", "#009C36"]
        },
        {
            "id": "palette7",
            "ranges": ["#F0F0F0", "#B9B9B9", "#FFBD59", "#FFBD59", "#000000"]
        },
        {
            "id": "palette8",
            "ranges": ["#00909E", "#B9B9B9", "#FFBD59", "#FFBD59", "#000000"]
        }
    ],
    "themes": [
        {
            "id": "colorTheme1",
            "name": "colorTheme1",
            "charts": [
                {
                    "type": "pie",
                    "ranges": ["palette1"]
                },
                {
                    "type": "donut",
                    "ranges": ["palette1"]
                },
                {
                    "type": "combo",
                    "ranges": ["palette3", "palette4", "palette1", "palette5", "palette2"]
                },
                {
                    "type": "line",
                    "ranges": ["palette3", "palette4", "palette5"]
                },
                {
                    "type": "bar",
                    "ranges": ["palette3", "palette4", "palette1","palette3", "palette4", "palette1"]
                },
                {
                    "type": "bar2",
                    "ranges": ["palette6", "palette4", "palette5", "palette1"]
                },
                {
                    "type": "summary",
                    "ranges": ["palette8"]
                },
                {
                    "type": "summary2",
                    "ranges": ["palette8"]
                },
                {
                    "type": "bubble",
                    "ranges": ["palette1", "palette2", "palette3", "palette4", "palette5"]
                },
                {
                    "type": "stacked",
                    "ranges": ["palette1", "palette2", "palette3", "palette4", "palette5"]
                },
                {
                    "type": "treemap",
                    "ranges": ["palette1", "palette2", "palette3", "palette4", "palette5"]
                },
                {
                    "type": "radialBar",
                    "ranges": ["palette1"]
                },
                {
                    "type": "radialBar2",
                    "ranges": ["palette1"]
                },
                {
                    "type": "advancedTable",
                    "ranges": ["palette7"]
                }
            ],
            "sidebar": {
                "ranges": ["palette6"]
            }
        },
        {
            "id": "colorTheme2",
            "name": "colorTheme2",
            "charts": [
                {
                    "type": "pie",
                    "ranges": ["palette2"]
                },
                {
                    "type": "donut",
                    "ranges": ["palette2"]
                },
                {
                    "type": "combo",
                    "ranges": ["palette3", "palette4", "palette5", "palette1", "palette2"]
                },
                {
                    "type": "line",
                    "ranges": ["palette3", "palette4", "palette5"]
                },
                {
                    "type": "bar",
                    "ranges": ["palette3", "palette4", "palette5", "palette1"]
                },
                {
                    "type": "bar2",
                    "ranges": ["palette4", "palette3", "palette5", "palette1"]
                },
                {
                    "type": "summary",
                    "ranges": ["palette1"]
                },
                {
                    "type": "summary2",
                    "ranges": ["palette1"]
                },
                {
                    "type": "bubble",
                    "ranges": ["palette1", "palette2", "palette3", "palette4", "palette5"]
                },
                {
                    "type": "stacked",
                    "ranges": ["palette1", "palette2", "palette3", "palette4", "palette5"]
                },
                {
                    "type": "treemap",
                    "ranges": ["palette1", "palette2", "palette3", "palette4", "palette5"]
                },
                {
                    "type": "radialBar",
                    "ranges": ["palette1"]
                },
                {
                    "type": "radialBar2",
                    "ranges": ["palette1"]
                },
                {
                    "type": "advancedTable",
                    "ranges": ["palette1"]
                }
            ]
        },
        {
            "id": "colorTheme3",
            "name": "colorTheme3",
            "charts": [
                {
                    "type": "pie",
                    "ranges": ["palette2"]
                },
                {
                    "type": "donut",
                    "ranges": ["palette2"]
                },
                {
                    "type": "combo",
                    "ranges": ["palette3", "palette4", "palette5", "palette1", "palette2"]
                },
                {
                    "type": "line",
                    "ranges": ["palette3", "palette4", "palette5"]
                },
                {
                    "type": "bar",
                    "ranges": ["palette3", "palette4", "palette5", "palette1"]
                },
                {
                    "type": "bar2",
                    "ranges": ["palette5", "palette4", "palette3", "palette1"]
                },
                {
                    "type": "summary",
                    "ranges": ["palette1"]
                },
                {
                    "type": "summary2",
                    "ranges": ["palette1"]
                },
                {
                    "type": "bubble",
                    "ranges": ["palette1", "palette2", "palette3", "palette4", "palette5"]
                },
                {
                    "type": "stacked",
                    "ranges": ["palette1", "palette2", "palette3", "palette4", "palette5"]
                },
                {
                    "type": "treemap",
                    "ranges": ["palette1", "palette2", "palette3", "palette4", "palette5"]
                },
                {
                    "type": "radialBar",
                    "ranges": ["palette1"]
                },
                {
                    "type": "radialBar2",
                    "ranges": ["palette1"]
                },
                {
                    "type": "advancedTable",
                    "ranges": ["palette1"]
                }
            ]
        }

    ]
}